module.exports = __webpack_public_path__ + "public/img/face-recognition.6bc400c3.png";